import { Component, Input, EventEmitter, Output, OnInit } from '@angular/core';

import { DynamicComponent } from 'hisng';

import { Project } from '../../../finance/model/project/project';
import { Habilitation } from '../../../doctoral/model/habilitation';
import { Publication } from '../../../publication/model/publication';
import { ResearchContract, ResearchContractFund } from '../../model/finance/research-contract-classes';
import { ResearchInfrastructure } from '../../../research-infrastructure/model/research-infrastructure';

@Component( {
    selector: 'res-research-tab',
    templateUrl: './research-tab.component.html',
} )
export class ResearchTabComponent {
    @Input() editMode = true;
    @Input() dDKeyProject: string;
    @Input() projects: Project[];
    @Output() projectsChange = new EventEmitter<Project[]>();

    @Input() showFundingPrograms = false;
    @Input() dDKeyFundingProgram: string;
    @Input() fundingPrograms: ResearchContract[];
    @Output() fundingProgramsChange = new EventEmitter<ResearchContract[]>();

    @Input() dDKeyPublication: string;
    @Input() publicationsAreOptional: boolean;
    @Input() publications: Publication[];
    @Output() publicationsChange = new EventEmitter<Publication[]>();

    @Input() dDKeyDoctorates: string;
    @Input() doctorates: Habilitation[];
    @Output() doctoratesChange = new EventEmitter<Habilitation[]>();

    @Input() dDKeyResearchInfrastructures: string;
    @Input() researchInfrastructures: ResearchInfrastructure[];
    @Output() researchInfrastructuresChange = new EventEmitter<ResearchInfrastructure[]>();

    @Output() onBeforeNavigate = new EventEmitter();

    @Input() dynamicComponent: DynamicComponent;

    onProjectsChange( event: Project[] ) {
        this.projectsChange.emit( event );
    }

    onPublicationsChange( event: Publication[] ) {
        this.publicationsChange.emit( event );
    }

    onDoctoratesChange( event: Habilitation[] ) {
        this.doctoratesChange.emit( event );
    }

    onInfrastructuresChange(event: ResearchInfrastructure[] ) {
        this.researchInfrastructuresChange.emit(event);
    }
}
